import { AccountsTable } from './AccountsTable'
import { useIntl } from 'react-intl'
import React, { useEffect, useState, useRef } from 'react'
import { MenuComponent } from '../../../_metronic/assets/ts/components'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../setup'
import exportDocx from './word'
import exportEmptyBbaDocx from './emptyBbaWord'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select'
import { UserModel } from '../auth/models/UserModel'
import { authFetch } from '../auth/redux/AuthFetch'
import * as auth from '../auth'
import { useAuth } from '../auth/hooks/UseAuth'
import { Roles } from '../auth/roles'
import jwt from 'jwt-decode'
import { AccessToken_I } from '../auth/models/AccessTokenModel'
import { apiUrl as host } from '../../../setup/appConfig'
type Props = {
  className: string

}

export interface InquiryLI {
  id: string;
  requestDateTime: string;
  issuerDocumentId: string;
  requesteeDocumentId: string;
  requesteeFullName: string;
  legalBasisNote: string;
  documentPurposeNote: string;
  address: string;
  chargible: boolean;
  jmb: string;
  lck: string;
  psp: string;
  pid: string;
  bban: string;
  iban: string;
  fullName: string;
  payerName: string;
  payingDate: string;
  body: string;
}

export interface InquiryBbaLI {
  id: string;
  requestDateTime: string;
  issuerDocumentId: string;
  requesteeDocumentId: string;
  requesteeFullName: string;
  address: string;
  chargible: boolean;
  jib: string;
  bban: string;
  iban: string;
  entityName: string;
  payerName: string;
  payingDate: string;
  body: string;
  userName: string;
}

export interface SearchBankAccountCast {
  accountId: number
  uniqueNationalId: string
  accountHolder: boolean
  individualEntityId: string
  individualEntityName: string
  individualEntityLocation: string

  businessEntityId: string
  businessEntityName: string
  businessEntityLocation: string

  bank: string
  bankCode: number
  bic: string
  iban: string
  bban: string
  type: string
  status: string
  statusDateTime: string
  typeDateTime: string
  EntityIdEntity: number
}

export interface SearchBankAccount {
  accountId: number
  uniqueNationalId: string
  accountHolder: boolean

  individualEntityId: string
  individualEntityName: string
  individualEntityLocation: string

  businessEntityId: string
  businessEntityName: string
  businessEntityLocation: string

  bank: string
  bankCode: number
  bic: string
  iban: string
  bban: string
  type: string
  status: string
  statusDateTime: Date
  typeDateTime: Date
  entityIdEntity: number
  entityIdAccount: number
  bankIdAccount: number
  bankIdEntity: number
  isErrorAccount: boolean
}

const footer = [{ bold1: 'Napomena: ', text1: 'Korisnici podatke iz Registra mogu koristiti radi obavljanja poslova u okviru zakonom utvrđene nadležnosti isključivo u svrhu za koje su pribavljeni i ne mogu ih dalje saopštavati ili dostavljati trećim licima, niti tim licima omogućiti pristup ovim podacima, osim u slučajevima utvrđenim Zakonom', bold2: '', text2: '' }, { bold1: 'Status računa: ', text1: 'A - aktivan, B - blokiran, U - ugašen', bold2: 'Vrsta računa: ', text2: 'R - redovni, G - glavni, O - račun organizacionog odjela, P - posebne namjene, J - za prikupljanje javnih prihoda, D - devizni, K - depozit koji predstavlja kolateral, S - račun poslovnog subjekta koji je u stečaju, F - finansijska konsolidacija' }]

class Signature {
  label1: string
  label2: string
  label3: string
  rightIndentLine1: bigint
  rightIndentLine2: bigint
  rightIndentLine3: bigint
  verticalSpacing1: bigint
  verticalSpacing2: bigint
  verticalSpacing3: bigint

  constructor(label1: string, label2: string, label3: string, rightIndentLine1: bigint, rightIndentLine2: bigint, rightIndentLine3: bigint, verticalSpacing1: bigint, verticalSpacing2: bigint, verticalSpacing3: bigint) {
    this.label1 = label1;
    this.label2 = label2;
    this.label3 = label3;
    this.rightIndentLine1 = rightIndentLine1;
    this.rightIndentLine2 = rightIndentLine2;
    this.rightIndentLine3 = rightIndentLine3;
    this.verticalSpacing1 = verticalSpacing1;
    this.verticalSpacing2 = verticalSpacing2;
    this.verticalSpacing3 = verticalSpacing3;
  }
}

export interface SearchFLinterface {
  RequestId: string;
  UserName: string;
  LegalEntity: string;
  JMB: string;
  LCK: string;
  PSP: string;
  PID: string;
  BBAN: string;
  IBAN: string;
  Firstname: string;
  Lastname: string;
  JMBS: string;

}

export class SearchFL implements SearchFLinterface {
  constructor(public RequestId: string, public UserName: string, public LegalEntity: string, public JMB: string, public LCK: string, public PSP: string, public PID: string, public BBAN: string, public IBAN: string, public Firstname: string, public Lastname: string, public JMBS: string) { }
}

class RequesteeNames {
  labelpuni: string
  label: string
  value: string
  constructor(label: string, value: string, labelPuni: string) {
    this.label = label;
    this.value = value;
    this.labelpuni = labelPuni;
  }
}

class Dpn {
  label: string
  value: string
  constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }
}

class Lbn {
  label: string
  value: string
  constructor(label: string, value: string) {
    this.label = label
    this.value = value
  }
}

const AccountSearch: React.FC<Props> = ({ className }) => {
  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
  const [allowWord, setAllowWord] = useState(true);
  const [isChoosen, setIsChoosen] = useState(false)
  const [signatures, setSignatures] = useState<Signature[]>([]);
  const intl = useIntl()
  const accessToken: any = useSelector<RootState>(({ auth }) => auth.accessToken, shallowEqual)
  const [array, fillArray] = useState<SearchBankAccount[]>([])
  const [arrayG, fillArrayG] = useState<SearchBankAccount[]>([])
  const [selectedItem, setOnSelectedItem] = useState(Object);
  const [IssuerDocumentIdValue, setIssuerDocumentId] = useState('')
  const [RequesteeDocumentIdValue, setRequesteeDocumentId] = useState('')
  const [RequesteeFullNameValue, setRequesteeFullName] = useState('')
  const [PayerFullNameValue, setPayerFullName] = useState('');
  const [RequesteeAddress, setAddress] = useState('')
  const [LegalBasisNoteValue, setLegalBasisNote] = useState('')
  const [DocumentPurposeNoteValue, setDocumentPurposeNote] = useState('')
  const [FullName, setFullName] = useState('');
  const [EntityName, setEntityName] = useState('');
  const [EntityNameBba, setEntityNameBba] = useState('');
  const [hasResults, setHasResults] = useState('');
  const [EntityNameG, setEntityNameG] = useState('');
  const [uniqueEntityIdG, setUniqueEntityIdG] = useState('');
  const [businessEntityIdValue, businessEntityIdentifier] = useState('')
  const [uniqueNationalIdValue, uniqueNationalIdentifier] = useState('')
  const [passportIdValue, passportIdentifier] = useState('')
  const [personalIdCardValue, personalCardIdentifier] = useState('')
  const [personalIdDocumentValue, personalDocumentIdentifier] = useState('')
  const [bbanValue, accountBban] = useState('')
  const [ibanValue, accountIban] = useState('')
  const [firstname, setFirstName] = useState('');
  const [lastname, setLastName] = useState('');
  const [idcodeBook, setIdCodeBook] = useState(0);
  const [uploadchecker, setUploadChecker] = useState(false)
  const [searchByFirstAndLastName] = useState(false);
  const [requestid, setRequestId] = useState('')
  const [legalInquiryDateTime] = useState('')
  const [requestees, setRequestees] = useState<RequesteeNames[]>([])
  const [payers, setPayers] = useState<RequesteeNames[]>([])
  const [resourceDPN, setResourceDPN] = useState<Dpn[]>([])
  const [resourceLBN, setResourceLBN] = useState<Lbn[]>([])
  const [content, setContent] = useState('')
  const [NumberOfRequestIDs] = useState();
  const [NumberOfRealResponses] = useState();
  const [NumberOfImagineResponses] = useState();
  const [JMBexcelPretraga] = useState('');
  const [selectedNamesOption, setSelectedNameOption] = useState(new RequesteeNames('', '', ''));
  const [selectedPayerNameOption, setSelectedPayerNameOption] = useState(new RequesteeNames('', '', ''));
  const [selectedDpn, setSelectedDpn] = useState(new Dpn('', ''));
  const [selectedLbn, setSelectedLbn] = useState(new Lbn('', ''));
  const [searchDate, setSearchDate] = useState([]);
  const [searchRequesteeDate, setSearchRequesteeDate] = useState([]);
  const [requesteeDocumentDate, setRequesteeDocumentDate] = useState('1900-01-01');
  const [paymentDate_d, setPaymentDate_d] = useState('1900-01-01');
  const [setSearchDateString] = useState('');
  const [birthDateString, setBirthDateString] = useState('');
  const [upozorenje, setUpozorenje] = useState(false);
  const [Inqarray, fillInqArray] = useState<InquiryLI[]>([]);
  const [InqarrayBba, fillInqBbaArray] = useState<InquiryBbaLI[]>([]);
  const [isChecked, setIsChecked] = useState(false);
  const [showNoResultMessage, setShowNoResultMessage] = useState('');
  const [allowedEntityNameField, setAllowedEntityNameField] = useState(false);

  var LegalInquiryBbaArray: InquiryBbaLI[] = [];

  const fileInputRef = useRef<any>();
  const colorStyles = {
    control: (base: any) => ({ ...base, backgroundColor: '#EFF2F5', borderColor: '#EFF2F5', fontFamily: 'Inherit', fontSize: '1.1rem', fontWeight: '500', color: '#FFFFFF' })
  };

  const checkHandler = () => {
    var c = !isChecked;
    setIsChecked(c);
    if (!c) {
      setPayerFullName('');
      setPaymentDate_d('1900-01-01');
      setSelectedPayerNameOption(new RequesteeNames('', '', ''));
    }
  }

  let { roleList } = useAuth()

  useEffect(() => {
    if (roleList.includes(Roles.Bba)) {
      setAllowedEntityNameField(true);
      setAllowWord(true);
    }
    else {
      setAllowedEntityNameField(false);
      setAllowWord(false);
    }

    setContent('IZVOD IZ JEDINSTVENOG REGISTRA RAČUNA POSLOVNIH SUBJEKATA FEDERACIJE BiH');
  }, [accessToken]);
  const onKeyDownHandler = (e: any) => {
    if (e.keyCode === 13) {
      getBankAccounts();
    }
  };

  const onChangeEntityNameG = (event: any) => {
    setEntityNameG(event.target.value)
  }

  const onChangeEntityNameBba = (event: any) => {
    setEntityNameBba(event.target.value);
    businessEntityIdentifier('');
    accountBban('');
    accountIban('');
  }

  const onChangeIssuerDocumentId = (event: any) => {
    setIssuerDocumentId(event.target.value)
  }

  const onChangeRequesteeDocumentId = (event: any) => {
    setRequesteeDocumentId(event.target.value)
  }

  const onChangeRequesteeFullName = (event: any) => {
    setRequesteeFullName(event.target.value)
    if (event.target.value === '' || event.target.value === null || event.target.value === undefined) {
      setSelectedPayerNameOption(new RequesteeNames('', '', ''));
      setSelectedNameOption(new RequesteeNames('', '', ''));
      setAddress('');
      setPayerFullName('');
    }
  }

  const onChangePayerFullName = (event: any) => {
    setPayerFullName(event.target.value)
    if (event.target.value === '' || event.target.value === null || event.target.value === undefined) {
      setSelectedPayerNameOption(new RequesteeNames('', '', ''));
    }
  }

  const onChangeAddress = (event: any) => {
    setAddress(event.target.value);
  }

  const onChangeBusinessEntityIdentifier = (event: any) => {
    businessEntityIdentifier(event.target.value)
    setShowNoResultMessage('');
    accountBban('');
    accountIban('');
    setFirstName('');
    setLastName('');
    setSearchDate([]);
    setIsChoosen(false);
    setEntityNameBba('');
    if (fileInputRef.current) {
      fileInputRef.current!.value = null;
    }
  }

  const onChangeAccountBban = (event: any) => {
    accountBban(event.target.value)
    setShowNoResultMessage('');
    uniqueNationalIdentifier('');
    personalCardIdentifier('');
    passportIdentifier('');
    personalDocumentIdentifier('');
    accountIban('');
    setFirstName('');
    setLastName('');
    setSearchDate([]);
    businessEntityIdentifier('')
    setIsChoosen(false)
    setEntityNameBba('')
    if (fileInputRef.current) {
      fileInputRef.current!.value = null;
    }
  }

  const onChangeAccountIban = (event: any) => {
    accountIban(event.target.value)
    setShowNoResultMessage('');
    uniqueNationalIdentifier('');
    personalCardIdentifier('');
    passportIdentifier('');
    personalDocumentIdentifier('');
    accountBban('');
    setFirstName('');
    setLastName('');
    setSearchDate([]);
    businessEntityIdentifier('')
    setIsChoosen(false)
    setEntityNameBba('')
    if (fileInputRef.current) {
      fileInputRef.current!.value = null;
    }
  }

  const onChangeDateOfPayment = (event: any) => {
    setPaymentDate_d(event.target.value);
  }

  function changeSignature() {

    const clientId: string = process.env.REACT_APP_CLIENT_ID || '6CAC6ED4-EDA2-4A30-BF01-29CD88E52F44'
    const options = {
      method: 'GET',
      withCredentials: true,
      headers: {
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        ClientId: clientId,
        Authorization: accessToken,
      },
    }

    var endpoint = `${host}/Inquiry/ChangeSignature?RetreiveAll=true`;

    authFetch(
      endpoint,
      options
    )
      .then((res) => {
        return res.json();
      })
      .then(
        (result) => {
          setSignatures(result);
          setOnSelectedItem(result[0]);

          return result.resultList;
        },
        (error) => {
          return []
        }
      )

  }

  function getInquiriesbba(JIB: string, BBAN: string, IBAN: string) {
    const clientId: string = process.env.REACT_APP_CLIENT_ID || '6CAC6ED4-EDA2-4A30-BF01-29CD88E52F44'
    const options = {
      method: 'GET',
      withCredentials: true,
      headers: {
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        ClientId: clientId,
        Authorization: accessToken,
      },
    }

    var endpoint = `${host}/inquiry/LegalInquiriesBbaById?RetrieveAll=true&`;

    if (JIB !== '') {
      endpoint = endpoint + 'JIB=' + JIB + '&';
    }
    if (BBAN !== '') {
      endpoint = endpoint + 'BBAN=' + BBAN + '&';
    }
    if (IBAN !== '') {
      endpoint = endpoint + 'IBAN=' + IBAN + '&';
    }

    if (endpoint !== `${host}/inquiry/LegalInquiriesBbaById?RetrieveAll=true&`) {
      authFetch(
        endpoint,
        options
      )
        .then((res) => {
          return res.json();
        })
        .then(
          (result) => {
            if (result.resultList !== null && result.resultList !== undefined) {
              for (var i = 0; i < result.resultList.length; i++) {
                LegalInquiryBbaArray.push(result.resultList[i] as InquiryBbaLI)
              }
            }

            fillInqBbaArray([...LegalInquiryBbaArray])

            MenuComponent.reinitialization()

            if (result.resultList.length !== 0 && (JSON.parse(result.resultList[0].body).count !== 0)) {
              if (JIB === (JSON.parse(result.resultList[0].body).resultList[0].uniqueEntityId ? JSON.parse(result.resultList[0].body).resultList[0].uniqueEntityId : '')) {
                alert('Postoji izvod urađen za ovu pretragu');
              }
              else if (result.resultList[0].bban === BBAN || result.resultList[0].iban) {
                alert('Postoji izvod urađen za ovu pretragu');
              }
            }
            let countRes = result.count ? result.count : result.resultList.count ? result.resultList.count : 0
            if (countRes !== 0) {
              if (JSON.parse(result.resultList[0].body).count === 0 && (result.resultList[0].bban === BBAN || result.resultList[0].iban)) {
                alert('Postoji izvod urađen za ovu pretragu');
              }
            }
          },
          (error) => {
            return []
          }
        )
    }

  }

  var BankAccountsArray: SearchBankAccount[] = [];
  var BankAcoountsArrayG: SearchBankAccount[] = [];

  function showToastMessage() {
    toast('Nema podataka u bazi...', { position: toast.POSITION.BOTTOM_CENTER, autoClose: 2000, type: 'error' });
  }

  const getSignatures = () => {
    const clientId: string = process.env.REACT_APP_CLIENT_ID || '6CAC6ED4-EDA2-4A30-BF01-29CD88E52F44'
    const options = {
      method: 'GET',
      withCredentials: true,
      headers: {
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        ClientId: clientId,
        Authorization: accessToken,
      },
    }

    var endpoint = `${host}/Inquiry/Signatures?RetrieveAll=true&`;

    authFetch(
      endpoint,
      options
    )
      .then((res) => {
        return res.json();
      })
      .then(
        (result) => {
          setSignatures(result.resultList);
          setOnSelectedItem(result.resultList[0]);
          return result.resultList;
        },
        (error) => {
          return []
        }
      )
  }

  const getLegalInquiries = () => {
    const clientId: string = process.env.REACT_APP_CLIENT_ID || '6CAC6ED4-EDA2-4A30-BF01-29CD88E52F44'
    const options = {
      method: 'GET',
      withCredentials: true,
      headers: {
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        ClientId: clientId,
        Authorization: accessToken,
      },
    }

    var endpoint = `${host}/Inquiry/Requestees?RetrieveAll=true&`;

    authFetch(
      endpoint,
      options
    )
      .then((res) => {
        return res.json();
      })
      .then(
        (result) => {
          const update_resource = result.resultList[0].requestees ? result.resultList[0].requestees.map((item: any) => ({ labelPuni: item.longNameCodeBook, label: item.shortNameCodeBook, value: item.address, id: item.id })) : '';
          const update_resource_Dpn = result.resultList[0].documentPurposes ? result.resultList[0].documentPurposes.map((item: any) => ({ label: item.documentPurposeNote, value: item.documentPurposeNote })) : '';
          const update_resource_LBN = result.resultList[0].legalBases ? result.resultList[0].legalBases.map((item: any) => ({ label: item.legalBasisNote, value: item.legalBasisNote })) : '';

          setRequestees(update_resource ? update_resource : '');
          setPayers(update_resource ? update_resource : '');
          setResourceDPN(update_resource_Dpn ? update_resource_Dpn : '');
          setResourceLBN(update_resource_LBN ? update_resource_LBN : '');

          return result.resultList;
        },
        (error) => {
          return []
        }
      )
  }

  function getBankAccounts() {
    setAllowWord(true);
    setIsChecked(false);
    setUniqueEntityIdG('');
    setEntityNameG('');
    setEntityName('');
    setEntityNameBba('');
    fillArray([]);
    fillArrayG([]);
    setBirthDateString('');
    setSearchRequesteeDate([]);
    setIssuerDocumentId('');
    setRequesteeDocumentId('');
    setRequesteeFullName('');
    setAddress('');
    setLegalBasisNote('');
    setDocumentPurposeNote('');
    setOnSelectedItem(signatures[0]);
    setRequestId('');
    setFullName('');
    setRequestees([]);
    setResourceDPN([]);
    setResourceLBN([]);
    setSelectedDpn(new Dpn('', ''));
    setSelectedNameOption(new RequesteeNames('', '', ''));
    setSelectedLbn(new Lbn('', ''));
    (allowedEntityNameField) ? getSignatures() : console.log('NoPerSig');
    (allowedEntityNameField) ? getLegalInquiries() : console.log('NoPerLeg');
    setUpozorenje(false);
    setPayerFullName('');
    setSelectedPayerNameOption(new RequesteeNames('', '', ''));
    setPaymentDate_d('1900-01-01');

    var spin = document.querySelector("#search-spin");
    var zoom = document.querySelector("#search-zoom");

    if (spin != null && zoom != null) {
      spin.removeAttribute("hidden");
      zoom.setAttribute("hidden", "true");
    }

    if (spin != null && zoom != null) {
      spin.removeAttribute("hidden");
      zoom.setAttribute("hidden", "true");
    }

    if (businessEntityIdValue === '' && bbanValue === '' && ibanValue === '' && EntityNameBba === '') {
      alert('Molimo vas upišite vrijednosti za filtere pretrage!')
      if (spin != null && zoom != null) {
        spin.setAttribute("hidden", "true");
        zoom.removeAttribute("hidden");
      }
    }
    else {
      const clientId: string = process.env.REACT_APP_CLIENT_ID || '6CAC6ED4-EDA2-4A30-BF01-29CD88E52F44'
      const options = {
        method: 'GET',
        withCredentials: true,
        headers: {
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
          ClientId: clientId,
          Authorization: accessToken,
        },
      }

      var endpoint = `${host}/businessentitybankaccounts?RetrieveAll=true&`;
      if (businessEntityIdValue !== '') {
        endpoint = endpoint + 'BusinessEntityId=' + businessEntityIdValue + '&';
      }
      if (bbanValue !== '') {
        endpoint = endpoint + 'Bban=' + bbanValue + '&';
      }
      if (ibanValue !== '') {
        endpoint = endpoint + 'Iban=' + ibanValue + '&';
      }
      if (EntityNameBba != '') {
        setAllowWord(false);
        endpoint = `${host}/inquiry/GetAccount?RetrieveAll=true&EntityName=${EntityNameBba}&`;
      }
      authFetch(
        endpoint,
        options
      )
        .then((res) => {
          return res.json();
        })
        .then((result) => {
          setRequestId(result.requestId);
          if (result.resultList !== null && result.resultList !== undefined) {
            for (var i = 0; i < result.resultList.length; i++) {
              BankAccountsArray.push(result.resultList[i] as SearchBankAccount)
              if ((result.resultList[i].type ?? '').startsWith('G')) {
                BankAcoountsArrayG.push(result.resultList[i] as SearchBankAccount)
              }
            }
          }

          fillArray([...BankAccountsArray])
          fillArrayG([...BankAcoountsArrayG])

          MenuComponent.reinitialization()

          if (spin != null && zoom != null) {
            spin.setAttribute("hidden", "true");
            zoom.removeAttribute("hidden");
          }

          let p_jmb = '';
          let p_jib = '';

          if (result.resultList.length !== 0) {
            p_jmb = result.resultList[0].uniqueNationalId ? result.resultList[0].uniqueNationalId : '';
            p_jib = result.resultList[0].businessEntityId ? result.resultList[0].businessEntityId : '';
          }
          else {
            p_jmb = uniqueNationalIdValue ? uniqueNationalIdValue : '';
            p_jib = businessEntityIdValue ? businessEntityIdValue : '';
          }

          (allowedEntityNameField) ? getInquiriesbba(p_jib, bbanValue, ibanValue) : console.log('NoPerInqbba');

          if (result.resultList.length !== 0) {
            var arr = result.resultList.map((i: any) => ({
              param: i.businessEntityName
            }));

            const uniqueArr = [...new Set(arr.map((obj: any) => obj.param))]
            const uniqueArrComa = uniqueArr.map((i: any) => `${i}`).join(',');

            if (uniqueArr.length > 1) {
              alert('Provjerite podatke, za isti JIB pronađena su pravna lica sa različitim nazivima!!');
            }

            setEntityName(uniqueArrComa.toString());

            setEntityNameG(result.resultList[0].businessEntityName.toString());
            setUniqueEntityIdG(result.resultList[0].businessEntityId.toString());

            setHasResults('1');
          }
          else {
            setHasResults('0');
            setShowNoResultMessage('0');
            showToastMessage();
          }

          return BankAccountsArray
        },
          (error) => {
            return []
          }
        )
    }

  }

  function generateBbaDOCX(
    accounts: SearchBankAccount[],
    iba: boolean,
    bba: boolean,
    issuerDocumentId: string,
    requesteeDocumentId: string,
    requesteeFullName: string,
    RequesteeAddress: string,
    selectedItem: any,
    content: any,
    footerArticle: any,
    uploadchecker: any,
    glavni: boolean) {
    // const test = [...array];
    if (array.length > 0) {
      for (let i = 0; i < array.length; i++) {
        array[i].businessEntityName = array[i].businessEntityName.trim().replace(/&/g, '<![CDATA[&]]>');

        array[i].type = (array[i].type ?? '').trim();
        array[i].status = array[i].status.trim();
      }
    }

    const json2xml = require('json2xml');
    const xmlData = json2xml({ legalInquiry: array });
    const xmlDataG = json2xml({ legalInquiry: arrayG });
    footerArticle = footer[1];
    var userid = '';
    var endpoint = `${host}/legalinquiry`;
    const clientId: string = process.env.REACT_APP_CLIENT_ID || '6CAC6ED4-EDA2-4A30-BF01-29CD88E52F44'
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ClientId: clientId,
        Authorization: accessToken,
      },
      body: JSON.stringify({
        id: requestid,
        issuerDocumentId: issuerDocumentId,
        requesteeDocumentId: requesteeDocumentId,
        requesteeFullName: requesteeFullName,
        // legalBasisNote: legalBasisNote,
        // documentPurposeNote: documentPurposeNote,
        address: RequesteeAddress,
        BodyColumn: !glavni ? xmlData : xmlDataG,
        Chargible: isChecked,
        NumberOfRequestIDs: 1,
        NumberOfRealResponses: !glavni ? array.length : arrayG.length,
        NumberOfImagineResponses: !glavni ? (array.length === 0 ? 1 : 0) : (arrayG.length === 0 ? 1 : 0),
        JIB: businessEntityIdValue,
        BBAN: bbanValue,
        IBAN: ibanValue,
        UserName: user.username,
        PayerName: PayerFullNameValue,
        PayingDate: paymentDate_d,
        EntityName: (bba && accounts.length === 0) ? EntityNameG : EntityName,
        TypeOfExport: glavni ? 'Word glavni izvod' : 'Word izvod',
        idcodeBook: idcodeBook
        , LegalInquiryDateTime: legalInquiryDateTime
        , SearchById: (businessEntityIdValue && !bbanValue && !ibanValue && !EntityName) ? 9 :
          (!businessEntityIdValue && bbanValue && !ibanValue && !EntityName) ? 5 :
            (!businessEntityIdValue && !bbanValue && ibanValue && !EntityName) ? 6 :
              (!businessEntityIdValue && !bbanValue && !ibanValue && EntityName) ? 10 : 0
      })
    };

    authFetch(endpoint, requestOptions)
      .then(async response => {
        const isJson = response.headers.get('content-type')?.includes('application/json');
        const data = isJson && await response.json();

        if (response.status === 200) {
          if (glavni === true) {
            var array1 = array.filter((item: any) => item.type.startsWith('G'));
            array1.length > 0 ? exportDocx(array1, iba, bba, IssuerDocumentIdValue, RequesteeDocumentIdValue, RequesteeFullNameValue, RequesteeAddress, LegalBasisNoteValue, DocumentPurposeNoteValue, selectedItem, content, footerArticle, uploadchecker, glavni) : alert('Ne postoji glavni račun za pretragu koju ste uradili!');
          }
          else {
            array.length > 0 ? exportDocx(array, iba, bba, IssuerDocumentIdValue, RequesteeDocumentIdValue, RequesteeFullNameValue, RequesteeAddress, LegalBasisNoteValue, DocumentPurposeNoteValue, selectedItem, content, footerArticle, uploadchecker, glavni) : alert('Prazan izvod');
          }
        }
        // check for error response
        if (!response.ok) {
          // get error message from body or default to response status
          const error = (data && data.message) || response.status;
          return Promise.reject(error);
        }
      })
      .catch(error => {
        alert('There was an error!');
      });

    fillArray([])
    fillArrayG([]);
    setIssuerDocumentId('');
    setRequesteeDocumentId('');
    setRequesteeFullName('');
    setAddress('');
    setLegalBasisNote('');
    setDocumentPurposeNote('');
    setHasResults('');
    setIsChecked(false);
  }

  function generateEmptyBbaDOCX(accounts: SearchBankAccount[], iba: boolean, bba: boolean, issuerDocumentId: string, requesteeDocumentId: string, requesteeFullName: string, RequesteeAddress: string, selectedItem: any, content: string, FullName: string, businessEntityIdValue: string, glavni: boolean) {
    if (array.length > 0) {
      for (let i = 0; i < array.length; i++) {
        array[i].businessEntityName = array[i].businessEntityName.trim().replace(/&/g, '<![CDATA[&]]>');
        array[i].type = array[i].type.trim();
        array[i].status = array[i].status.trim();
      }
    }

    const json2xml = require('json2xml');
    const xmlData = json2xml({ legalInquiry: array });
    const xmlDataG = json2xml({ legalInquiry: arrayG });

    let footerArticle = footer[1];
    var userid = '';

    var endpoint = `${host}/legalinquiry`;

    const clientId: string = process.env.REACT_APP_CLIENT_ID || '6CAC6ED4-EDA2-4A30-BF01-29CD88E52F44'
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ClientId: clientId,
        Authorization: accessToken,
      },
      body: JSON.stringify({
        id: requestid,
        issuerDocumentId: issuerDocumentId,
        requesteeDocumentId: requesteeDocumentId,
        requesteeFullName: requesteeFullName,
        // legalBasisNote: legalBasisNote,
        // documentPurposeNote: documentPurposeNote,
        address: RequesteeAddress,
        BodyColumn: glavni ? xmlDataG : xmlData,
        Chargible: isChecked,
        NumberOfRequestIDs: 1,
        NumberOfRealResponses: glavni ? arrayG.length : array.length,
        NumberOfImagineResponses: glavni ? (arrayG.length === 0 ? 1 : 0) : (array.length === 0 ? 1 : 0),
        JIB: businessEntityIdValue,
        BBAN: bbanValue,
        IBAN: ibanValue,
        UserName: user.username,
        PayerName: PayerFullNameValue,
        PayingDate: paymentDate_d,
        EntityName: EntityName ? EntityName : EntityNameG ? EntityNameG : '',
        TypeOfExport: glavni ? 'Word glavni izvod' : 'Word izvod',
        idCodeBook: idcodeBook
        , LegalInquiryDateTime: legalInquiryDateTime
        , SearchById: (businessEntityIdValue && !bbanValue && !ibanValue && !EntityName) ? 9 :
          (!businessEntityIdValue && bbanValue && !ibanValue && !EntityName) ? 5 :
            (!businessEntityIdValue && !bbanValue && ibanValue && !EntityName) ? 6 :
              (!businessEntityIdValue && !bbanValue && !ibanValue && EntityName) ? 10 : 0
      })
    };

    authFetch(endpoint, requestOptions)
      .then(async response => {
        const isJson = response.headers.get('content-type')?.includes('application/json');
        const data = isJson && await response.json();
        if (response.status === 200) {
          if (glavni === true) {
            exportEmptyBbaDocx(arrayG, iba, bba, IssuerDocumentIdValue, RequesteeDocumentIdValue, RequesteeFullNameValue, LegalBasisNoteValue, DocumentPurposeNoteValue, selectedItem, RequesteeAddress, content, footerArticle, uploadchecker, FullName, uniqueNationalIdValue, businessEntityIdValue, glavni, uniqueEntityIdG, EntityNameG);
          }
          else {
            exportEmptyBbaDocx(array, iba, bba, IssuerDocumentIdValue, RequesteeDocumentIdValue, RequesteeFullNameValue, LegalBasisNoteValue, DocumentPurposeNoteValue, selectedItem, RequesteeAddress, content, footerArticle, uploadchecker, FullName, uniqueNationalIdValue, businessEntityIdValue, glavni, uniqueEntityIdG, EntityNameG);
          }
        }
        // check for error response
        if (!response.ok) {
          // get error message from body or default to response status
          const error = (data && data.message) || response.status;
          return Promise.reject(error);
        }
      })
      .catch(error => {
        alert('There was an error!');
      });

    setUploadChecker(false);
    fillArray([]);
    fillArrayG([]);
    setIssuerDocumentId('');
    setRequesteeDocumentId('');
    setRequesteeFullName('');
    setAddress('');
    setLegalBasisNote('');
    setDocumentPurposeNote('');
    setFullName('');
    setHasResults('');
    setIsChecked(false);
  }


  const bbaView = () => {

    return <div className={`card ${className}`}>
      <div className='col-xxl-12' style={{ width: "100%", position: "relative", backgroundColor: "#cfe2f3", alignSelf: "center" }}>
        <div className='card-header align-items-center border-0 mt-4' style={{ width: "100%", position: "relative", backgroundColor: "#cfe2f3", alignSelf: "center" }}>

          <div className='input-group'>

            <div className='col-12 col-sm-6 col-lg-3' style={{ paddingBottom: "3%" }}>
              <div className='d-flex align-items-center position-relative my-1'>
                <h3 className='card-title align-items-start flex-column' style={{ marginBottom: "1%" }}>
                  <span className='fw-bolder mb-2 text-dark'>
                    {intl.formatMessage({ id: 'ACCOUNT.SEARCHBANKACCOUNTS' })}
                  </span>
                </h3>
              </div>
            </div>

            <div className='col-12 col-sm-6 col-lg-3' style={{ paddingBottom: "3%" }}>
              <div className='d-flex align-items-center position-relative my-1'>

              </div>
            </div>

            <div className='col-12 col-sm-6 col-lg-3' style={{ paddingBottom: "3%" }}>
              <div className='d-flex align-items-center position-relative my-1'>

              </div>
            </div>
          </div>

          <div className='input-group'>

            <div className='col-12 col-sm-6 col-lg-3' style={{ paddingBottom: "2%" }}>
              <div className='d-flex align-items-center position-relative my-1'>
                <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                  <span className='svg-icon svg-icon-1'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path opacity="0.3" d="M21 10.7192H3C2.4 10.7192 2 11.1192 2 11.7192C2 12.3192 2.4 12.7192 3 12.7192H6V14.7192C6 18.0192 8.7 20.7192 12 20.7192C15.3 20.7192 18 18.0192 18 14.7192V12.7192H21C21.6 12.7192 22 12.3192 22 11.7192C22 11.1192 21.6 10.7192 21 10.7192Z" fill="currentColor" />
                      <path d="M11.6 21.9192C11.4 21.9192 11.2 21.8192 11 21.7192C10.6 21.4192 10.5 20.7191 10.8 20.3191C11.7 19.1191 12.3 17.8191 12.7 16.3191C12.8 15.8191 13.4 15.4192 13.9 15.6192C14.4 15.7192 14.8 16.3191 14.6 16.8191C14.2 18.5191 13.4 20.1192 12.4 21.5192C12.2 21.7192 11.9 21.9192 11.6 21.9192ZM8.7 19.7192C10.2 18.1192 11 15.9192 11 13.7192V8.71917C11 8.11917 11.4 7.71917 12 7.71917C12.6 7.71917 13 8.11917 13 8.71917V13.0192C13 13.6192 13.4 14.0192 14 14.0192C14.6 14.0192 15 13.6192 15 13.0192V8.71917C15 7.01917 13.7 5.71917 12 5.71917C10.3 5.71917 9 7.01917 9 8.71917V13.7192C9 15.4192 8.4 17.1191 7.2 18.3191C6.8 18.7191 6.9 19.3192 7.3 19.7192C7.5 19.9192 7.7 20.0192 8 20.0192C8.3 20.0192 8.5 19.9192 8.7 19.7192ZM6 16.7192C6.5 16.7192 7 16.2192 7 15.7192V8.71917C7 8.11917 7.1 7.51918 7.3 6.91918C7.5 6.41918 7.2 5.8192 6.7 5.6192C6.2 5.4192 5.59999 5.71917 5.39999 6.21917C5.09999 7.01917 5 7.81917 5 8.71917V15.7192V15.8191C5 16.3191 5.5 16.7192 6 16.7192ZM9 4.71917C9.5 4.31917 10.1 4.11918 10.7 3.91918C11.2 3.81918 11.5 3.21917 11.4 2.71917C11.3 2.21917 10.7 1.91916 10.2 2.01916C9.4 2.21916 8.59999 2.6192 7.89999 3.1192C7.49999 3.4192 7.4 4.11916 7.7 4.51916C7.9 4.81916 8.2 4.91918 8.5 4.91918C8.6 4.91918 8.8 4.81917 9 4.71917ZM18.2 18.9192C18.7 17.2192 19 15.5192 19 13.7192V8.71917C19 5.71917 17.1 3.1192 14.3 2.1192C13.8 1.9192 13.2 2.21917 13 2.71917C12.8 3.21917 13.1 3.81916 13.6 4.01916C15.6 4.71916 17 6.61917 17 8.71917V13.7192C17 15.3192 16.8 16.8191 16.3 18.3191C16.1 18.8191 16.4 19.4192 16.9 19.6192C17 19.6192 17.1 19.6192 17.2 19.6192C17.7 19.6192 18 19.3192 18.2 18.9192Z" fill="currentColor" />
                    </svg>
                  </span>
                </span>
                <input
                  value={businessEntityIdValue}
                  onChange={onChangeBusinessEntityIdentifier}
                  onKeyDown={onKeyDownHandler}
                  type='text'
                  data-kt-customer-table-filter='search'
                  className='form-control form-control-solid ps-15 me-3'
                  placeholder='JIB'
                  required
                />
              </div>
            </div>

            <div className='col-12 col-sm-6 col-lg-3' style={{ paddingBottom: "3%" }}>
              <div className='d-flex align-items-center position-relative my-1'>
                <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <g stroke='none' fill='none'>
                      <rect x='0' y='0' width='24' height='24' />
                      <rect fill='#000000' opacity='0.3' x='4' y='4' width='8' height='16' />
                      <path
                        d='M6,18 L9,18 C9.66666667,18.1143819 10,18.4477153 10,19 C10,19.5522847 9.66666667,19.8856181 9,20 L4,20 L4,15 C4,14.3333333 4.33333333,14 5,14 C5.66666667,14 6,14.3333333 6,15 L6,18 Z M18,18 L18,15 C18.1143819,14.3333333 18.4477153,14 19,14 C19.5522847,14 19.8856181,14.3333333 20,15 L20,20 L15,20 C14.3333333,20 14,19.6666667 14,19 C14,18.3333333 14.3333333,18 15,18 L18,18 Z M18,6 L15,6 C14.3333333,5.88561808 14,5.55228475 14,5 C14,4.44771525 14.3333333,4.11438192 15,4 L20,4 L20,9 C20,9.66666667 19.6666667,10 19,10 C18.3333333,10 18,9.66666667 18,9 L18,6 Z M6,6 L6,9 C5.88561808,9.66666667 5.55228475,10 5,10 C4.44771525,10 4.11438192,9.66666667 4,9 L4,4 L9,4 C9.66666667,4 10,4.33333333 10,5 C10,5.66666667 9.66666667,6 9,6 L6,6 Z'
                        fill='#000000'
                      />
                    </g>
                  </svg>
                </span>
                <input
                  value={bbanValue}
                  onChange={onChangeAccountBban}
                  onKeyDown={onKeyDownHandler}
                  type='text'
                  data-kt-customer-table-filter='search'
                  className='form-control form-control-solid ps-15 me-3'
                  placeholder={intl.formatMessage({ id: 'ACCOUNT.BANKACCOUNT' })}
                  required
                />
              </div>
            </div>

            <div className='col-12 col-sm-6 col-lg-3' style={{ paddingBottom: "3%" }}>
              <div className='d-flex align-items-center position-relative my-1'>
                <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'>
                    <g stroke='none' fill='none'>
                      <rect x='0' y='0' width='24' height='24' />
                      <rect fill='#000000' opacity='0.3' x='4' y='4' width='8' height='16' />
                      <path
                        d='M6,18 L9,18 C9.66666667,18.1143819 10,18.4477153 10,19 C10,19.5522847 9.66666667,19.8856181 9,20 L4,20 L4,15 C4,14.3333333 4.33333333,14 5,14 C5.66666667,14 6,14.3333333 6,15 L6,18 Z M18,18 L18,15 C18.1143819,14.3333333 18.4477153,14 19,14 C19.5522847,14 19.8856181,14.3333333 20,15 L20,20 L15,20 C14.3333333,20 14,19.6666667 14,19 C14,18.3333333 14.3333333,18 15,18 L18,18 Z M18,6 L15,6 C14.3333333,5.88561808 14,5.55228475 14,5 C14,4.44771525 14.3333333,4.11438192 15,4 L20,4 L20,9 C20,9.66666667 19.6666667,10 19,10 C18.3333333,10 18,9.66666667 18,9 L18,6 Z M6,6 L6,9 C5.88561808,9.66666667 5.55228475,10 5,10 C4.44771525,10 4.11438192,9.66666667 4,9 L4,4 L9,4 C9.66666667,4 10,4.33333333 10,5 C10,5.66666667 9.66666667,6 9,6 L6,6 Z'
                        fill='#000000' />
                    </g>
                  </svg>
                </span>
                <input
                  value={ibanValue}
                  onChange={onChangeAccountIban}
                  onKeyDown={onKeyDownHandler}
                  type='text'
                  data-kt-customer-table-filter='search'
                  className='form-control form-control-solid ps-15 me-3'
                  placeholder={intl.formatMessage({ id: 'ACCOUNT.IBAN' })}
                  required
                />
              </div>
            </div>

            {allowedEntityNameField ? <div className='col-12 col-sm-6 col-lg-3' style={{ paddingBottom: "3%" }}>
              <div className='d-flex align-items-center position-relative my-1'>
                <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'>
                    <g stroke='none' fill='none'>
                      <rect x='0' y='0' width='24' height='24' />
                      <rect fill='#000000' opacity='0.3' x='4' y='4' width='8' height='16' />
                      <path
                        d='M6,18 L9,18 C9.66666667,18.1143819 10,18.4477153 10,19 C10,19.5522847 9.66666667,19.8856181 9,20 L4,20 L4,15 C4,14.3333333 4.33333333,14 5,14 C5.66666667,14 6,14.3333333 6,15 L6,18 Z M18,18 L18,15 C18.1143819,14.3333333 18.4477153,14 19,14 C19.5522847,14 19.8856181,14.3333333 20,15 L20,20 L15,20 C14.3333333,20 14,19.6666667 14,19 C14,18.3333333 14.3333333,18 15,18 L18,18 Z M18,6 L15,6 C14.3333333,5.88561808 14,5.55228475 14,5 C14,4.44771525 14.3333333,4.11438192 15,4 L20,4 L20,9 C20,9.66666667 19.6666667,10 19,10 C18.3333333,10 18,9.66666667 18,9 L18,6 Z M6,6 L6,9 C5.88561808,9.66666667 5.55228475,10 5,10 C4.44771525,10 4.11438192,9.66666667 4,9 L4,4 L9,4 C9.66666667,4 10,4.33333333 10,5 C10,5.66666667 9.66666667,6 9,6 L6,6 Z'
                        fill='#000000' />
                    </g>
                  </svg>
                </span>
                <input
                  value={EntityNameBba}
                  onChange={onChangeEntityNameBba}
                  onKeyDown={onKeyDownHandler}
                  type='text'
                  data-kt-customer-table-filter='search'
                  className='form-control form-control-solid ps-15 me-3'
                  placeholder={intl.formatMessage({ id: 'ACCOUNT.ENTITY_NAME' })}
                  required
                />
              </div>
            </div>
              : null}
          </div>

          <div className='input-group'>
            <div className='col-3 col-sm-3 col-lg-3' style={{ paddingBottom: "1%" }}>
              <div className='d-flex align-items-center position-relative my-0  mx-0'>
                <button className='btn btn-secondary my-1' onClick={resetInputField} style={{ backgroundColor: "#cd513d", color: 'white', width: "50%", marginRight: "1%" }} title='Kliknite da poništite unose u tekstualnim poljima'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M14.5 20.7259C14.6 21.2259 14.2 21.826 13.7 21.926C13.2 22.026 12.6 22.0259 12.1 22.0259C9.5 22.0259 6.9 21.0259 5 19.1259C1.4 15.5259 1.09998 9.72592 4.29998 5.82592L5.70001 7.22595C3.30001 10.3259 3.59999 14.8259 6.39999 17.7259C8.19999 19.5259 10.8 20.426 13.4 19.926C13.9 19.826 14.4 20.2259 14.5 20.7259ZM18.4 16.8259L19.8 18.2259C22.9 14.3259 22.7 8.52593 19 4.92593C16.7 2.62593 13.5 1.62594 10.3 2.12594C9.79998 2.22594 9.4 2.72595 9.5 3.22595C9.6 3.72595 10.1 4.12594 10.6 4.02594C13.1 3.62594 15.7 4.42595 17.6 6.22595C20.5 9.22595 20.7 13.7259 18.4 16.8259Z" fill="currentColor" />
                    <path opacity="0.3" d="M2 3.62592H7C7.6 3.62592 8 4.02592 8 4.62592V9.62589L2 3.62592ZM16 14.4259V19.4259C16 20.0259 16.4 20.4259 17 20.4259H22L16 14.4259Z" fill="currentColor" />
                  </svg>
                  <span className="pl-5">
                    {intl.formatMessage({ id: 'ACCOUNT.CLEAR' })}{' '}
                  </span>
                </button>
                <button
                  type='submit'
                  className='btn btn-secondary my-1'
                  onClick={() => getBankAccounts()}
                  style={{ background: "#009ef7", color: "white", width: "50%", marginLeft: "1%", marginRight: "2.5%" }}
                  title='Kliknite za pretragu računa'>
                  <svg id="search-zoom" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor" />
                    <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="currentColor" />
                  </svg>
                  <span id="search-spin" hidden className="spinner-border spinner-border-sm align-middle"></span>
                  <span className="pl-5">
                    {intl.formatMessage({ id: 'ACCOUNT.SEARCH' })}{' '}
                  </span>
                </button>
              </div>
            </div>

          </div>

          <ToastContainer />

        </div>
      </div>

      {/* begin::Body */}
      {
        (array.length > 0) ?
          (
            <AccountsTable className='col-xxl-12' parentToChild={array} /> // pravna lica
          )
          :
          (showNoResultMessage === '0') ? (
            <div className='card-header border-0 pt-5 '>
              <h3 className='card-title align-items-start flex-column'>
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {intl.formatMessage({ id: 'ACCOUNT.NORESULTS' })}
                </span>
              </h3>
            </div>
          )
            :
            (
              <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='text-muted mt-1 fw-bold fs-7'>

                  </span>
                </h3>
              </div>
            )
      }

      {
        (array.length > 0 && hasResults === '1' && allowedEntityNameField && allowWord === true) ?
          (
            <div className='col-xxl-12' style={{ width: "100%", position: "relative", backgroundColor: "#ffffffff", alignSelf: "center" }}>
              <div className='card-header large-results align-items-center border-0 mt-4' style={{ width: "100%", position: "relative", backgroundColor: "#cfe2f3", alignSelf: "center" }}>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='fw-bolder mb-2 text-dark'>
                    POTVRDA/IZVOD IZ JEDINSTVENOG REGISTRA POSLOVNIH SUBJEKATA FEDERACIJE BiH
                  </span>
                </h3>
                <div className='row'>

                  <div className='col-6 col-sm-3 col-lg-6'>
                    <div className='d-flex align-items-center position-relative my-1'>
                      <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                        <span className='svg-icon svg-icon-1'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path opacity="0.3" d="M18 22C19.7 22 21 20.7 21 19C21 18.5 20.9 18.1 20.7 17.7L15.3 6.30005C15.1 5.90005 15 5.5 15 5C15 3.3 16.3 2 18 2H6C4.3 2 3 3.3 3 5C3 5.5 3.1 5.90005 3.3 6.30005L8.7 17.7C8.9 18.1 9 18.5 9 19C9 20.7 7.7 22 6 22H18Z" fill="currentColor" />
                            <path d="M18 2C19.7 2 21 3.3 21 5H9C9 3.3 7.7 2 6 2H18Z" fill="currentColor" />
                            <path d="M9 19C9 20.7 7.7 22 6 22C4.3 22 3 20.7 3 19H9Z" fill="currentColor" />
                          </svg>
                        </span>
                      </span>
                      <input
                        value={IssuerDocumentIdValue}
                        onChange={onChangeIssuerDocumentId}
                        type='text'
                        data-kt-customer-table-filter='search'
                        className='form-control form-control-solid ps-15 kore'
                        placeholder='Broj protokola'
                        required
                      />
                    </div>
                  </div>

                  <div className='col-6 col-sm-3 col-lg-6'>
                    <div className='d-flex align-items-center position-relative my-1'>
                      <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                        <span className='svg-icon svg-icon-1'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path opacity="0.3" d="M18 22C19.7 22 21 20.7 21 19C21 18.5 20.9 18.1 20.7 17.7L15.3 6.30005C15.1 5.90005 15 5.5 15 5C15 3.3 16.3 2 18 2H6C4.3 2 3 3.3 3 5C3 5.5 3.1 5.90005 3.3 6.30005L8.7 17.7C8.9 18.1 9 18.5 9 19C9 20.7 7.7 22 6 22H18Z" fill="currentColor" />
                            <path d="M18 2C19.7 2 21 3.3 21 5H9C9 3.3 7.7 2 6 2H18Z" fill="currentColor" />
                            <path d="M9 19C9 20.7 7.7 22 6 22C4.3 22 3 20.7 3 19H9Z" fill="currentColor" />
                          </svg>
                        </span>
                      </span>
                      <input
                        value={RequesteeDocumentIdValue}
                        onChange={onChangeRequesteeDocumentId}
                        type='text'
                        data-kt-customer-table-filter='search'
                        className='form-control form-control-solid ps-15 kore'
                        placeholder='Broj zahtjeva'
                        required
                      />
                    </div>
                  </div>

                  <div className='col-6 col-sm-3 col-lg-6' >
                    <div className='d-flex align-items-center position-relative my-1' style={{ backgroundColor: "#EFF2F5", borderRadius: "0.475rem" }}>
                      <input
                        style={{
                          height: 20, width: 20, padding: "10%", marginLeft: "20px"
                        }}
                        type="checkbox"
                        id="checkbox"
                        checked={isChecked}
                        onChange={checkHandler}
                      />
                      <label htmlFor="checkbox" style={{ color: isChecked ? "#5E6278" : "orangered", fontStyle: "normal", textAlign: "center", verticalAlign: "center", fontSize: "15px", paddingBottom: "10px", paddingTop: "10px", paddingLeft: "10px" }}>
                        Označiti ukoliko se izvod naplaćuje
                      </label>
                    </div>
                  </div>

                  <div className='col-6 col-sm-3 col-lg-6'>
                    <div className='d-flex align-items-center position-relative my-1'>
                      <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                        <span className='svg-icon svg-icon-1'>

                        </span>
                      </span>
                      <input
                        value=''
                        type='text'
                        data-kt-customer-table-filter='search'
                        className='form-control form-control-solid ps-15 kore'
                        placeholder=''
                        required
                        inputMode='none'
                        disabled
                        title='Nije potrbno popunjavati ovo polje'
                      />
                    </div>
                  </div>

                  <div className='col-6 col-sm-3 col-lg-6'>

                    <div className='d-flex align-items-center position-relative my-1'>
                      <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                        <span className='svg-icon svg-icon-1'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M6.28548 15.0861C7.34369 13.1814 9.35142 12 11.5304 12H12.4696C14.6486 12 16.6563 13.1814 17.7145 15.0861L19.3493 18.0287C20.0899 19.3618 19.1259 21 17.601 21H6.39903C4.87406 21 3.91012 19.3618 4.65071 18.0287L6.28548 15.0861Z" fill="currentColor" />
                            <rect opacity="0.3" x="8" y="3" width="8" height="8" rx="4" fill="currentColor" />
                          </svg>
                        </span>
                      </span>
                      <input
                        value={RequesteeFullNameValue}
                        onChange={onChangeRequesteeFullName}
                        type='text'
                        data-kt-customer-table-filter='search'
                        className='form-control form-control-solid ps-15 kore'
                        placeholder='Podnosilac zahtjeva'
                        required
                        disabled
                      />
                      <Select classNamePrefix="select" styles={colorStyles} noOptionsMessage={() => 'Ne postoji traženi odabir'} className='col-3 col-sm-3 col-lg-3' defaultValue={selectedNamesOption} options={requestees} onChange={(e: any) => { setSelectedNameOption(new RequesteeNames(e?.label === 'Podnosilac zahtjeva' ? '' : e?.label, e?.value, e?.labelPuni)); /*console.log('RequesteeFullName: ' + e.label + ' ,RequesteeAddres: ' + e.value);*/ setAddress(e.value); setRequesteeFullName(e.labelPuni); isChecked ? setPayerFullName(e.labelPuni) : setPayerFullName(''); setSelectedPayerNameOption(new RequesteeNames('', '', '')); setIdCodeBook(e.id); }} />
                    </div>
                  </div>

                  <div className='col-6 col-sm-3 col-lg-6'>
                    <div className='d-flex align-items-center position-relative my-1'>
                      <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                        <span className='svg-icon svg-icon-1'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M6.28548 15.0861C7.34369 13.1814 9.35142 12 11.5304 12H12.4696C14.6486 12 16.6563 13.1814 17.7145 15.0861L19.3493 18.0287C20.0899 19.3618 19.1259 21 17.601 21H6.39903C4.87406 21 3.91012 19.3618 4.65071 18.0287L6.28548 15.0861Z" fill="currentColor" />
                            <rect opacity="0.3" x="8" y="3" width="8" height="8" rx="4" fill="currentColor" />
                          </svg>
                        </span>
                      </span>
                      <input
                        value={RequesteeAddress}
                        onChange={onChangeAddress}
                        type='text'
                        data-kt-customer-table-filter='search'
                        className='form-control form-control-solid ps-15 kore'
                        placeholder='Adresa podnosioca zahtjeva'
                        required
                        disabled
                      />
                    </div>
                  </div>

                  <div className='col-6 col-sm-3 col-lg-6' hidden={(!isChecked)} >
                    <div className='d-flex align-items-center position-relative my-1'  >
                      <span className='svg-icon svg-icon-1 position-absolute ms-6'  >
                        <span className='svg-icon svg-icon-1' >
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M6.28548 15.0861C7.34369 13.1814 9.35142 12 11.5304 12H12.4696C14.6486 12 16.6563 13.1814 17.7145 15.0861L19.3493 18.0287C20.0899 19.3618 19.1259 21 17.601 21H6.39903C4.87406 21 3.91012 19.3618 4.65071 18.0287L6.28548 15.0861Z" fill="currentColor" />
                            <rect opacity="0.3" x="8" y="3" width="8" height="8" rx="4" fill="currentColor" />
                          </svg>
                        </span>
                      </span>
                      <input
                        value={PayerFullNameValue}
                        onChange={onChangePayerFullName}
                        type='text'
                        data-kt-customer-table-filter='search'
                        className='form-control form-control-solid ps-15 kore'
                        placeholder='Uplatitelj zahtjeva'
                        required
                        disabled
                      />
                      <Select classNamePrefix="select" styles={colorStyles} noOptionsMessage={() => 'Ne postoji traženi odabir'} className='col-3 col-sm-3 col-lg-3' value={selectedPayerNameOption} defaultValue={selectedPayerNameOption} options={payers} onChange={(e: any) => { setSelectedPayerNameOption(new RequesteeNames(e?.label === 'Podnoslilac zahtjeva' ? '' : e?.label, e?.value, e?.labelPuni)); /*console.log('PayerFullName: ' + e.label + ' ,PayerAddres: ' + e.value);*/ setPayerFullName(e.label) }} />
                    </div>
                  </div>

                  <div className='col-6 col-sm-3 col-lg-6' hidden={(!isChecked)}>
                    <div className='d-flex align-items-center position-relative my-1'>
                      <span className='svg-icon svg-icon-1 position-absolute ms-6'>

                      </span>
                      <input
                        style={{ color: paymentDate_d === '1900-01-01' || paymentDate_d === '' ? "orangered" : "" }}
                        id='dateId'
                        value={paymentDate_d}
                        onChange={onChangeDateOfPayment}
                        //onKeyDown={onKeyDownHandler}
                        type='date'
                        data-kt-customer-table-filter='search'
                        className='form-control form-control-solid ps-4'
                        title={intl.formatMessage({ id: 'LEGALINQUIRY.PAYINGDATE' })}
                        required
                      />
                    </div>
                  </div>

                  <div className='col-6 col-sm-3 col-lg-6' >
                    <div className='d-flex align-items-center position-relative my-1'>
                      <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                        <span className='svg-icon svg-icon-1'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M6.28548 15.0861C7.34369 13.1814 9.35142 12 11.5304 12H12.4696C14.6486 12 16.6563 13.1814 17.7145 15.0861L19.3493 18.0287C20.0899 19.3618 19.1259 21 17.601 21H6.39903C4.87406 21 3.91012 19.3618 4.65071 18.0287L6.28548 15.0861Z" fill="currentColor" />
                            <rect opacity="0.3" x="8" y="3" width="8" height="8" rx="4" fill="currentColor" />
                          </svg>
                        </span>
                      </span>
                      <input
                        style={{ borderColor: 'white', borderWidth: 3 }}
                        value={signatures[0].label3}
                        //onChange={onChangeLegalBasisNote}
                        type='text'
                        data-kt-customer-table-filter='search'
                        className='form-control form-control-solid ps-15 kore'
                        placeholder='Potpisnik'
                        required
                      />
                      <button
                        style={{ width: '50%', background: '#FFC700', color: '#201f1f', borderColor: 'white', borderWidth: 30, backgroundRepeat: 'repeat' }}
                        type='submit'
                        className='btn btn-primary my-1'
                        onClick={() => changeSignature()}>
                        <span id="search-spin" hidden className="spinner-border spinner-border-sm align-middle"></span>
                        <span className="pl-5">
                          {intl.formatMessage({ id: 'SIGNATURES.CHANGE' })}{' '}
                        </span>
                      </button>
                    </div>
                  </div>

                  <div className='col-6 col-sm-3 col-lg-3 d-grid'>
                    <button className='btn btn-primary my-1' onClick={() => hasResults ? generateBbaDOCX(array, false, true, IssuerDocumentIdValue, RequesteeDocumentIdValue, RequesteeFullNameValue, RequesteeAddress, selectedItem, content, footer, uploadchecker, false) : generateEmptyBbaDOCX(array, false, true, IssuerDocumentIdValue, RequesteeDocumentIdValue, RequesteeFullNameValue, RequesteeAddress, selectedItem, content, FullName, businessEntityIdValue, false)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path opacity="0.3" d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14V4H6V20H18V8H20V21C20 21.6 19.6 22 19 22Z" fill="currentColor" />
                        <path d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z" fill="currentColor" />
                      </svg>
                      <span className="pl-5">
                        {intl.formatMessage({ id: 'ACCOUNT.GENERATEDOC' })}{' '}
                      </span>
                    </button>
                  </div>

                  <div className='col-6 col-sm-3 col-lg-3 d-grid'>
                    <button className='btn btn-primary my-1' onClick={() => arrayG.length > 0 ? generateBbaDOCX(arrayG, false, true, IssuerDocumentIdValue, RequesteeDocumentIdValue, RequesteeFullNameValue, RequesteeAddress, selectedItem, content, footer, uploadchecker, true) : (businessEntityIdValue) ? generateEmptyBbaDOCX(array, false, true, IssuerDocumentIdValue, RequesteeDocumentIdValue, RequesteeFullNameValue, RequesteeAddress, selectedItem, content, FullName, businessEntityIdValue, true) : alert('Navedeni račun nije označen kao glavni, uradite pretragu po JIB-u kako biste dobili glavni račun ili potvrdu da pravno lice nema glavni račun')}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path opacity="0.3" d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14V4H6V20H18V8H20V21C20 21.6 19.6 22 19 22Z" fill="currentColor" />
                        <path d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z" fill="currentColor" />
                      </svg>
                      <span className="pl-5">
                        {intl.formatMessage({ id: 'ACCOUNT.GENERATEDOC_G' })}{' '}
                      </span>
                    </button>
                  </div>

                </div>
              </div>
            </div>
          )
          :
          null
      }

      {
        (array.length === 0 && hasResults === '0' && allowedEntityNameField && allowWord) ?
          (
            <div className='col-xxl-12' style={{ width: "100%", position: "relative", backgroundColor: "#ffffff", alignSelf: "center" }}>
              <div className='card-header large-results align-items-center border-0 mt-4' style={{ width: "100%", position: "relative", backgroundColor: "#cfe2f3", alignSelf: "center" }}>

                <h3 className='card-title align-items-start flex-column'>
                  <span className='fw-bolder mb-2 text-dark'>
                    POTVRDA/IZVOD IZ JEDINSTVENOG REGISTRA POSLOVNIH SUBJEKATA FEDERACIJE BiH
                  </span>
                </h3>

                <div className='row'>

                  <div className='col-6 col-sm-3 col-lg-6'>
                    <div className='d-flex align-items-center position-relative my-1'>
                      <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                        <span className='svg-icon svg-icon-1'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path opacity="0.3" d="M18 22C19.7 22 21 20.7 21 19C21 18.5 20.9 18.1 20.7 17.7L15.3 6.30005C15.1 5.90005 15 5.5 15 5C15 3.3 16.3 2 18 2H6C4.3 2 3 3.3 3 5C3 5.5 3.1 5.90005 3.3 6.30005L8.7 17.7C8.9 18.1 9 18.5 9 19C9 20.7 7.7 22 6 22H18Z" fill="currentColor" />
                            <path d="M18 2C19.7 2 21 3.3 21 5H9C9 3.3 7.7 2 6 2H18Z" fill="currentColor" />
                            <path d="M9 19C9 20.7 7.7 22 6 22C4.3 22 3 20.7 3 19H9Z" fill="currentColor" />
                          </svg>
                        </span>
                      </span>
                      <input
                        value={IssuerDocumentIdValue}
                        onChange={onChangeIssuerDocumentId}
                        type='text'
                        data-kt-customer-table-filter='search'
                        className='form-control form-control-solid ps-15 kore'
                        placeholder='Broj protokola'
                        required
                      />
                    </div>
                  </div>

                  <div className='col-6 col-sm-3 col-lg-6'>
                    <div className='d-flex align-items-center position-relative my-1'>
                      <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                        <span className='svg-icon svg-icon-1'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path opacity="0.3" d="M18 22C19.7 22 21 20.7 21 19C21 18.5 20.9 18.1 20.7 17.7L15.3 6.30005C15.1 5.90005 15 5.5 15 5C15 3.3 16.3 2 18 2H6C4.3 2 3 3.3 3 5C3 5.5 3.1 5.90005 3.3 6.30005L8.7 17.7C8.9 18.1 9 18.5 9 19C9 20.7 7.7 22 6 22H18Z" fill="currentColor" />
                            <path d="M18 2C19.7 2 21 3.3 21 5H9C9 3.3 7.7 2 6 2H18Z" fill="currentColor" />
                            <path d="M9 19C9 20.7 7.7 22 6 22C4.3 22 3 20.7 3 19H9Z" fill="currentColor" />
                          </svg>
                        </span>
                      </span>
                      <input
                        value={RequesteeDocumentIdValue}
                        onChange={onChangeRequesteeDocumentId}
                        type='text'
                        data-kt-customer-table-filter='search'
                        className='form-control form-control-solid ps-15 kore'
                        placeholder='Broj zahtjeva'
                        required
                      />
                    </div>
                  </div>

                  <div className='col-6 col-sm-3 col-lg-6' >
                    <div className='d-flex align-items-center position-relative my-1' style={{ backgroundColor: "#EFF2F5", borderRadius: "0.475rem" }}>
                      <input
                        style={{
                          height: 20, width: 20, padding: "10%", marginLeft: "20px"
                        }}
                        type="checkbox"
                        id="checkbox"
                        checked={isChecked}
                        onChange={checkHandler}
                      />
                      <label htmlFor="checkbox" style={{ color: isChecked ? "#5E6278" : "orangered", fontStyle: "normal", textAlign: "center", verticalAlign: "center", fontSize: "15px", paddingBottom: "10px", paddingTop: "10px", paddingLeft: "10px" }}>
                        Označiti ukoliko se izvod naplaćuje
                      </label>
                    </div>
                  </div>

                  <div className='col-6 col-sm-3 col-lg-6'>
                    <div className='d-flex align-items-center position-relative my-1'>
                      <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                        <span className='svg-icon svg-icon-1'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M6.28548 15.0861C7.34369 13.1814 9.35142 12 11.5304 12H12.4696C14.6486 12 16.6563 13.1814 17.7145 15.0861L19.3493 18.0287C20.0899 19.3618 19.1259 21 17.601 21H6.39903C4.87406 21 3.91012 19.3618 4.65071 18.0287L6.28548 15.0861Z" fill="currentColor" />
                            <rect opacity="0.3" x="8" y="3" width="8" height="8" rx="4" fill="currentColor" />
                          </svg>
                        </span>
                      </span>
                      <input
                        value={EntityNameG}
                        onChange={onChangeEntityNameG}
                        type='text'
                        data-kt-customer-table-filter='search'
                        className='form-control form-control-solid ps-15 kore'
                        placeholder='Naziv poslovnog subjekta za koji je vršena pretraga'
                        required
                      />
                    </div>
                  </div>

                  <div className='col-6 col-sm-3 col-lg-6'>
                    <div className='d-flex align-items-center position-relative my-1'>
                      <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                        <span className='svg-icon svg-icon-1'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M6.28548 15.0861C7.34369 13.1814 9.35142 12 11.5304 12H12.4696C14.6486 12 16.6563 13.1814 17.7145 15.0861L19.3493 18.0287C20.0899 19.3618 19.1259 21 17.601 21H6.39903C4.87406 21 3.91012 19.3618 4.65071 18.0287L6.28548 15.0861Z" fill="currentColor" />
                            <rect opacity="0.3" x="8" y="3" width="8" height="8" rx="4" fill="currentColor" />
                          </svg>
                        </span>
                      </span>
                      <input
                        value={RequesteeFullNameValue}
                        onChange={onChangeRequesteeFullName}
                        type='text'
                        data-kt-customer-table-filter='search'
                        className='form-control form-control-solid ps-15 kore'
                        placeholder='Podnosilac zahtjeva'
                        required
                        disabled
                      />
                      <Select classNamePrefix="select" styles={colorStyles} noOptionsMessage={() => 'Ne postoji traženi odabir'} className='col-3 col-sm-3 col-lg-3' defaultValue={selectedNamesOption} options={requestees} onChange={(e: any) => { setSelectedNameOption(new RequesteeNames(e?.label === 'Podnosilac zahtjeva' ? '' : e?.label, e?.value, e?.labelPuni)); /*console.log('RequesteeFullName: ' + e.label + ' ,RequesteeAddres: ' + e.value);*/ setAddress(e.value); setRequesteeFullName(e.labelPuni); isChecked ? setPayerFullName(e.labelPuni) : setPayerFullName(''); setSelectedPayerNameOption(new RequesteeNames('', '', '')); setIdCodeBook(e.id); }} />
                    </div>
                  </div>

                  <div className='col-6 col-sm-3 col-lg-6'>
                    <div className='d-flex align-items-center position-relative my-1'>
                      <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                        <span className='svg-icon svg-icon-1'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M6.28548 15.0861C7.34369 13.1814 9.35142 12 11.5304 12H12.4696C14.6486 12 16.6563 13.1814 17.7145 15.0861L19.3493 18.0287C20.0899 19.3618 19.1259 21 17.601 21H6.39903C4.87406 21 3.91012 19.3618 4.65071 18.0287L6.28548 15.0861Z" fill="currentColor" />
                            <rect opacity="0.3" x="8" y="3" width="8" height="8" rx="4" fill="currentColor" />
                          </svg>
                        </span>
                      </span>
                      <input
                        value={RequesteeAddress}
                        onChange={onChangeAddress}
                        type='text'
                        data-kt-customer-table-filter='search'
                        className='form-control form-control-solid ps-15 kore'
                        placeholder='Adresa podnosioca zahtjeva'
                        required
                        disabled
                      />
                    </div>
                  </div>

                  <div className='col-6 col-sm-3 col-lg-6' hidden={(!isChecked)}>
                    <div className='d-flex align-items-center position-relative my-1'  >
                      <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                        <span className='svg-icon svg-icon-1'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M6.28548 15.0861C7.34369 13.1814 9.35142 12 11.5304 12H12.4696C14.6486 12 16.6563 13.1814 17.7145 15.0861L19.3493 18.0287C20.0899 19.3618 19.1259 21 17.601 21H6.39903C4.87406 21 3.91012 19.3618 4.65071 18.0287L6.28548 15.0861Z" fill="currentColor" />
                            <rect opacity="0.3" x="8" y="3" width="8" height="8" rx="4" fill="currentColor" />
                          </svg>
                        </span>
                      </span>
                      <input
                        value={PayerFullNameValue}
                        onChange={onChangePayerFullName}
                        type='text'
                        data-kt-customer-table-filter='search'
                        className='form-control form-control-solid ps-15 kore'
                        placeholder='Uplatitelj zahtjeva'
                        required
                        disabled
                      />
                      <Select classNamePrefix="select" styles={colorStyles} noOptionsMessage={() => 'Ne postoji traženi odabir'} className='col-3 col-sm-3 col-lg-3' value={selectedPayerNameOption} defaultValue={selectedPayerNameOption} options={payers} onChange={(e: any) => { setSelectedPayerNameOption(new RequesteeNames(e?.label === 'Podnoslilac zahtjeva' ? '' : e?.label, e?.value, e?.labelPuni)); /*console.log('PayerFullName: ' + e.label + ' ,PayerAddres: ' + e.value);*/ setPayerFullName(e.label) }} />
                    </div>
                  </div>

                  <div className='col-6 col-sm-3 col-lg-6' hidden={(!isChecked)}>
                    <div className='d-flex align-items-center position-relative my-1'>
                      <span className='svg-icon svg-icon-1 position-absolute ms-6'>

                      </span>
                      <input
                        style={{ color: paymentDate_d === '1900-01-01' || paymentDate_d === '' ? "orangered" : "" }}
                        id='dateId'
                        value={paymentDate_d}
                        onChange={onChangeDateOfPayment}
                        //onKeyDown={onKeyDownHandler}
                        type='date'
                        data-kt-customer-table-filter='search'
                        className='form-control form-control-solid ps-4'
                        title={intl.formatMessage({ id: 'LEGALINQUIRY.PAYINGDATE' })}
                        required
                      />
                    </div>
                  </div>

                  <div className='col-6 col-sm-3 col-lg-6' >
                    <div className='d-flex align-items-center position-relative my-1'>
                      <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                        <span className='svg-icon svg-icon-1'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M6.28548 15.0861C7.34369 13.1814 9.35142 12 11.5304 12H12.4696C14.6486 12 16.6563 13.1814 17.7145 15.0861L19.3493 18.0287C20.0899 19.3618 19.1259 21 17.601 21H6.39903C4.87406 21 3.91012 19.3618 4.65071 18.0287L6.28548 15.0861Z" fill="currentColor" />
                            <rect opacity="0.3" x="8" y="3" width="8" height="8" rx="4" fill="currentColor" />
                          </svg>
                        </span>
                      </span>
                      <input
                        style={{ borderColor: 'white', borderWidth: 3 }}
                        value={signatures[0].label3}
                        //onChange={onChangeLegalBasisNote}
                        type='text'
                        data-kt-customer-table-filter='search'
                        className='form-control form-control-solid ps-15 kore'
                        placeholder='Potpisnik'
                        required
                      />
                      <button
                        style={{ width: '50%', background: '#FFC700', color: '#201f1f', borderColor: 'white', borderWidth: 30, backgroundRepeat: 'repeat' }}
                        type='submit'
                        className='btn btn-primary my-1'
                        onClick={() => changeSignature()}>
                        <span id="search-spin" hidden className="spinner-border spinner-border-sm align-middle"></span>
                        <span className="pl-5">
                          {intl.formatMessage({ id: 'SIGNATURES.CHANGE' })}{' '}
                        </span>
                      </button>
                    </div>
                  </div>

                  <div className='col-3 col-sm-3 col-lg-3 d-grid'>
                    <button className='btn btn-primary my-1' onClick={() => generateEmptyBbaDOCX(array, false, true, IssuerDocumentIdValue, RequesteeDocumentIdValue, RequesteeFullNameValue, RequesteeAddress, selectedItem, content, FullName, businessEntityIdValue, false)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path opacity="0.3" d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14V4H6V20H18V8H20V21C20 21.6 19.6 22 19 22Z" fill="currentColor" />
                        <path d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z" fill="currentColor" />
                      </svg>
                      <span className="pl-5">
                        {intl.formatMessage({ id: 'ACCOUNT.GENERATEDOC' })}{' '}
                      </span>
                    </button>
                  </div>

                  <div className='col-3 col-sm-3 col-lg-3 d-grid'>
                    <button className='btn btn-primary my-1' onClick={() => arrayG.length > 0 ? generateBbaDOCX(arrayG, false, true, IssuerDocumentIdValue, RequesteeDocumentIdValue, RequesteeFullNameValue, RequesteeAddress, selectedItem, content, footer, uploadchecker, true) : (businessEntityIdValue) ? generateEmptyBbaDOCX(array, false, true, IssuerDocumentIdValue, RequesteeDocumentIdValue, RequesteeFullNameValue, RequesteeAddress, selectedItem, content, FullName, businessEntityIdValue, true) : alert('Navedeni račun nije označen kao glavni, uradite pretragu po JIB-u kako biste dobili glavni račun ili potvrdu da pravno lice nema glavni račun')}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path opacity="0.3" d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14V4H6V20H18V8H20V21C20 21.6 19.6 22 19 22Z" fill="currentColor" />
                        <path d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z" fill="currentColor" />
                      </svg>
                      <span className="pl-5">
                        {intl.formatMessage({ id: 'ACCOUNT.GENERATEDOC_G' })}{' '}
                      </span>
                    </button>
                  </div>

                </div>

              </div>
            </div>
          )
          :
          null
      }
      {/* end::Body */}
    </div>
  }

  const resetInputField = () => {
    setIssuerDocumentId('');
    setRequesteeDocumentId('');
    setRequesteeFullName('');
    setAddress('');
    setLegalBasisNote('');
    setDocumentPurposeNote('');

    setFirstName('');
    setLastName('');
    setSearchDate([]);
    uniqueNationalIdentifier('')
    personalCardIdentifier('')
    personalDocumentIdentifier('')
    passportIdentifier('')

    businessEntityIdentifier('')

    accountBban('')
    accountIban('')
    fillArray([])
    setIsChoosen(false)

    if (fileInputRef.current) {
      fileInputRef.current!.value = null;
    }
  }

  return bbaView();
}


export { AccountSearch }
